import {
  anno_v1_AnnoComment,
  anno_v1_Attr as SAttr,
  anno_v1_Element as SElement,
  anno_v1_Job,
  anno_v1_Label as SLabel,
  anno_v1_Object,
  anno_v1_Object_Widget,
  anno_v1_Rawdata as SRawdata,
} from '@/service/anno/v1';

export type {
  anno_v1_Object_Widget,
  anno_v1_AttrRefList as AttrRefList,
  anno_v1_ElementAnno as ElementAnno,
  anno_v1_Segmentation3dInstance as Instance,
  anno_v1_JobAnno as JobAnno,
  anno_v1_Job_CamParam as JobCamParam,
  anno_v1_Lot as Lot,
  anno_v1_Lotontologies as Lotontologies,
  anno_v1_Lotphase as LotPhase,
  anno_v1_Lot_Range as LotRange,
  anno_v1_Object_Label as ObjectLabel,
  anno_v1_Object as RawdataAnnoObject,
  anno_v1_RawdataParam as RawdataParam,
  types_Filelist as RawFileList,
  anno_v1_Segmentation3d as Segmentation3d,
  anno_v1_Segmentation3dStatistic as Statistic,
} from '@/service/anno/v1';

export interface WidgetObject extends anno_v1_Object_Widget {
  name: WidgetType;
  // 前端使用的方向值，相对于标注框，以中心点为原点（与 forward 注意区分开，forward 主要是用来传给后端）
  // 对于 2D 只有两个值，例如 [0,1,0], 最后一个值无效
  // 对于 3D 有三个值，例如 [0,0,1],
  direction?: [number, number, number];
}

export interface Label extends SLabel {
  labelIndex: number;
  // 添加默认属性值
  defaultAttrValues: Record<string, string[]>;
  // attrs 的全部信息
  fullAttrs: Attr[];
}

export interface Attr extends SAttr {
  required?: boolean;
  defaultValue?: string[];
}
export interface Rawdata extends SRawdata {
  originIndex?: number; // 标识当前 rawdata 位于 element.datas 数组的 index，仅用于点云图像融合类标注
  elementIndex?: number; // 标识当前 rawdata 所属的 element 的 index，也就是位于当前工作包的第几帧
}
export interface Element extends Omit<SElement, 'datas'> {
  datas: Array<Rawdata>;
  /**
   * 相对于第一帧的车姿数据，外参形式：[x, y, z, qx, qy, qz, qw]
   */
  relativePose?: number[];
}

export interface Job extends Omit<anno_v1_Job, 'elements'> {
  elements: Array<Element>;
  // 如果有 snapshot 的话，说明远程的缓存时间比 job 包里的数据更新
  snapshot?: unknown;
  /** 当前这个包的过期时间 */
  expired_at?: string;
  /** 这个包最近的修改时间，指的提交/驳回/通过这些，不包括远程缓存 */
  last_modify?: string;
}

export interface Comment extends anno_v1_AnnoComment {
  /**
   * 批注的状态：上级驳回返修的、下级提交给同级复查的、下级返修上级的批注（一般是当前批注是上级打的，下级已经修改好，此时只能查看无法添加新批注）
   * 本次新增的、本次刷新了同级批注的、本次已解决的批注
   */
  status?: 'pending' | 'unresolved' | 'resolved';
  /**
   * 批注的显示 id，形式为递增的整数字符串，只有漏标有
   */
  trackId?: string;
}

export type WidgetType = Exclude<anno_v1_Object_Widget['name'], 'unspecified'>;

// 运行时使用的帧属性类型
export interface ElementAttrValues {
  [key: string]: string[];
}

export type AnnoSourceType = Exclude<anno_v1_Object['source'], 'unspecified'>;

/** 保存数据的类型 */
export enum LabelDataSaveType {
  /** 本地 */
  LOCAL,
  /** 远程提交 */
  SERVER,
  /** 远程缓存 */
  DRAFT,
  /** 无标注信息 */
  NONE,
}

/** 标注数据的信息 */
export interface JobLabelDataInfo {
  // 最新的保存数据位置
  latestSaveType: LabelDataSaveType;
  /** 最新的远程保存时间，不区分是缓存还是他人提交, 如果为空字符串，则没有在远程保存过数据 */
  remoteLatestSaveTime: string;
}
